export default __webpack_public_path__ + "static/media/Oilseed.9b5d91ad.jpg";